import { render, staticRenderFns } from "./IndexDoLabel.vue?vue&type=template&id=13383c2b&scoped=true"
import script from "./IndexDoLabel.vue?vue&type=script&lang=js"
export * from "./IndexDoLabel.vue?vue&type=script&lang=js"
import style0 from "./IndexDoLabel.vue?vue&type=style&index=0&id=13383c2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13383c2b",
  null
  
)

export default component.exports